import { useLDFlag } from './launchDarkly';

export const usePulsarCommercialEntitlementsBanners = () =>
  useLDFlag('operations-l1-commercial-router-entitlements');

export const useShowCompositionRules = () =>
  useLDFlag('orion-show-composition-rules');

export const useIsFedNextEnabled = () => useLDFlag('fed_next_enabled');

export const useShowUserProfileSurvey = () =>
  useLDFlag('growth-show-user-profile-survey');

export const useDefaultPlanID = () => useLDFlag('growth-default-studio-plan');

export const useShowRegisteredAndPendingMemberPage = () =>
  useLDFlag('growth-show-pending-and-registered-member-page');

export const useDemoSupergraphInEnterpriseTrial = () =>
  useLDFlag('betelgeuse-demo-supergraph-in-enterprise-trial');

export const useShowApiKeysTab = () =>
  useLDFlag('identity-show-api-management-page');
